export const CLEAR_NEWS = 'CLEAR_NEWS';
export const CLEAR_ALL_NEWS = 'CLEAR_ALL_NEWS';
export const CLEAR_STATE = 'CLEAR_STATE';

export const DELETE_NEWS = 'DELETE_NEWS';
export const DELETE_NEWS_ERROR = 'DELETE_NEWS_ERROR';
export const DELETE_NEWS_SUCCESS = 'DELETE_NEWS_SUCCESS';

export const DELETE_MAIN_IMAGE = 'DELETE_MAIN_IMAGE';
export const DELETE_MAIN_IMAGE_ERROR = 'DELETE_MAIN_IMAGE_ERROR';
export const DELETE_MAIN_IMAGE_SUCCESS = 'DELETE_MAIN_IMAGE_SUCCESS';

export const DELETE_SUB_IMAGE = 'DELETE_SUB_IMAGE';
export const DELETE_SUB_IMAGE_ERROR = 'DELETE_SUB_IMAGE_ERROR';
export const DELETE_SUB_IMAGE_SUCCESS = 'DELETE_SUB_IMAGE_SUCCESS';


export const GET_CATEGORY = 'GET_CATEGORY';
export const GET_CATEGORY_ERROR = 'GET_CATEGORY_ERROR';
export const GET_CATEGORY_SUCCESS = 'GET_CATEGORY_SUCCESS';

export const GET_CATEGORY_BYID = 'GET_CATEGORY_BYID';
export const GET_CATEGORY_BYID_ERROR = 'GET_CATEGORY_BYID_ERROR';
export const GET_CATEGORY_BYID_SUCCESS = 'GET_CATEGORY_BYID_SUCCESS';

export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const DELETE_CATEGORY_ERROR = 'DELETE_CATEGORY_ERROR';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';

export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const CREATE_CATEGORY_ERROR = 'CREATE_CATEGORY_ERROR';
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';

export const GET_NEWS = 'GET_NEWS';
export const GET_NEWS_ERROR = 'GET_NEWS_ERROR';
export const GET_NEWS_SUCCESS = 'GET_NEWS_SUCCESS';

export const GET_ALL_NEWS = 'GET_ALL_NEWS';
export const GET_ALL_NEWS_ERROR = 'GET_ALL_NEWS_ERROR';
export const GET_ALL_NEWS_SUCCESS = 'GET_ALL_NEWS_SUCCESS';

export const SAVE_NEWS = 'SAVE_NEWS';
export const SAVE_NEWS_ERROR = 'SAVE_NEWS_ERROR';
export const SAVE_NEWS_SUCCESS = 'SAVE_NEWS_SUCCESS';

export const CREATE_NEWS = 'CREATE_NEWS';
export const CREATE_NEWS_ERROR = 'CREATE_NEWS_ERROR';
export const CREATE_NEWS_SUCCESS = 'CREATE_NEWS_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/News/constants.js